import { render, staticRenderFns } from "./SingleBarChart.vue?vue&type=template&id=1c68be6c&scoped=true&"
import script from "./SingleBarChart.vue?vue&type=script&lang=js&"
export * from "./SingleBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c68be6c",
  null
  
)

export default component.exports